<template>
  <div id="ingredient">
    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>采购溯源&nbsp;/&nbsp;食材管理</span>
        </div>
        <div style="display: flex;flex-wrap: wrap;align-items: center;">
            <Provinces @gain='gainSS'></Provinces>
            <!--<el-input class="elinputs" v-model="beginData.id" placeholder="食材id"></el-input> -->
           <el-input class="elinputs" v-model="beginData.name" placeholder=" 名称"></el-input>
           <el-input class="elinputs" v-model="beginData.place" placeholder=" 产地"></el-input>
           <el-input class="elinputs" v-model="beginData.supplierName" placeholder=" 供应商"></el-input>
            <el-button type="primary" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0.4)" v-loading.fullscreen.lock="fullscreenLoading" @click="query">查询</el-button>
            <el-button type="info" @click='reset'>重置</el-button>
        </div>
        <div class="tit">
            <Reset @clkBtn='theBtn'></Reset>
            <Xlsx :name="formname"></Xlsx>
        </div>
        <el-table :data="tableData" id="exportTab" @selection-change="handleSelectionChange" border stripe style="width: 100%">
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
            <el-table-column prop="name" label="名称" width="160"></el-table-column>
            <el-table-column prop="areasName" label="所属地区" min-width="140"></el-table-column>
            <el-table-column prop="num" label="数量" sortable width="120"></el-table-column>
            <el-table-column prop="place" label="产地" width="120"></el-table-column>
            <el-table-column prop="supplierName" label="供应商" width="200"></el-table-column>
            <el-table-column prop="manufacturer" label="生产厂家" width="200"></el-table-column>
            <el-table-column prop="productionTime" label="生产日期" width="180"></el-table-column>
            <el-table-column prop="days" label="保质期（天）" sortable width="160"></el-table-column>
            <el-table-column prop="buyerName" label="采购员" width="160"></el-table-column>
            <el-table-column label="是否上架" sortable width="160">
                <template slot-scope="scope">
                    <p class="boldfont" v-if="scope.row.isOnSale==1" style="color:#67C23A">是</p>
                    <p class="boldfont" v-else style="color:#F56C6C">否</p>
                </template>
            </el-table-column>
            <el-table-column prop="warehouseTime" label="入库时间" width="180"></el-table-column>
            <el-table-column prop="addTime" label="添加时间" width="180"></el-table-column>
            <el-table-column prop="updateTime" label="修改时间" width="180"></el-table-column>

            <el-table-column label="操作" fixed="right" min-width="200">
                <template slot-scope="scope">
                <el-button size="mini" type="success" @click="handleEdit(1,scope.row,'ingredient:update')"><i class="el-icon-edit"></i> 编辑</el-button>
                <el-button size="mini" type="danger" @click="stop(scope.row,'ingredient:delete')"><i class="el-icon-delete"></i> 删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="paging">
            <span>
            共
            <i class="pagingNum">{{total}}</i> 条
            </span>
            <Paging :gopage="total" @pag="pag"></Paging>
        </div>
    </el-card>
    <el-dialog :title="mydata.names" :visible.sync="dialogFormVisible" width="60%" @close="dataClose">
        <el-form>
            <!-- <div v-if='mydata.stat == 1||mydata.stat == 0'> -->
                <el-form-item label="* 所属地区">
                    <el-select v-model="sheng" placeholder="省份" @change="cksheng">
                        <el-option
                        v-for="item in shenglist"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select v-model="shi" placeholder="城市" @change="ckshi" class="cty16">
                        <el-option
                        v-for="item in shilist"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="* 名 称：">
                   <el-input placeholder="食材名称" v-model="mydata.name" auto-complete="off"></el-input>
                    <!-- <el-button size="small" type="primary" @click="innerVisible=true">点击选择出发地</el-button> -->
                </el-form-item>
                <el-form-item label="* 数 量：">
                   <el-input placeholder="数量" v-model="mydata.num" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="* 产 地：">
                   <el-input placeholder="产地" v-model="mydata.place" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="* 供应商：">
                    <el-select v-model="mydata.supplierId" placeholder="供应商选择">
                        <el-option
                        v-for="item in beginData.car"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="* 生产厂家：">
                   <el-input placeholder="生产厂家" v-model="mydata.manufacturer" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="* 生产日期：">
                    <div class="block">
                        <el-date-picker v-model="mydata.productionTime" type="datetime" value-format="yyyy-MM-dd HH:mm" placeholder="生产日期">
                        </el-date-picker>
                    </div>
                </el-form-item>
                <el-form-item label="* 保质天数：">
                   <el-input placeholder="保质天数" type="Number" v-model="mydata.days" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="* 采购员：">
                    <el-select v-model="mydata.buyerId" placeholder="采购员选择">
                        <el-option
                        v-for="item in beginData.driver"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="* 入库时间：">
                    <div class="block">
                        <el-date-picker v-model="mydata.warehouseTime" type="datetime" value-format="yyyy-MM-dd HH:mm" placeholder="入库时间">
                        </el-date-picker>
                    </div>
                </el-form-item>
                <el-form-item label="* 是否上架：">
                    <el-radio v-model="mydata.isOnSale" label=true>是</el-radio>
                    <el-radio v-model="mydata.isOnSale" label=false>否</el-radio>
                </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="puton">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import Provinces from "@/components/Provinces";
import Reset from "@/components/Reset";
import Xlsx from "@/components/Xlsx";
import EditorBar from '@/components/Richtext'
import Paging from '@/components/Paging';
export default {
  name: "ingredient",
  components: {
    Xlsx,
    EditorBar,
    Provinces,
    Reset,
    Paging
  },
  data() {
    return {
        beginData:{
            car:[],driver:[],gogogo:[{name:'待出发',id:'1'},{name:'在途中',id:'2'},{name:'已完成',id:'3'}]
        },
        tableData: [],
        pageNum: 1,
        pageSize: 10,
        dialogFormVisible: false,
        userdata: {},
        total: 0,
        btn: [],
        fullscreenLoading: true,
        formname:JSON.stringify({name:'食材管理',hint:'ingredient:export'}),
        sheng:'',
        shi:'',
        shenglist:[],
        shilist:[],
        mydata:{isOnSale:'true'},
        multipleSelection:[],
        innerVisible:false,
    };
  },
  created() {
    let userdata = JSON.parse(sessionStorage.getItem("userdata"));
    this.$set(this, "userdata", userdata);
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    this.begin();
  },
  computed: {
    data() {
      return this.tableData;
    }
  },
  mounted() {
    let region = JSON.parse(localStorage.getItem('region'))
    region.forEach(x => {
        if(x.level==0){
            this.shenglist.push(x)
            this.sheng=x.id
        }
    });
    if(this.userdata.level==0){
        this.$axios.post(`/api-r/area/getSubordinateAreaList`,this.$qs.stringify({areasId:region[0].id}),{headers:{accessToken:this.userdata.token}})
        .then(res=>{
            if(res.data.success){
                this.$set(this,'shilist',res.data.areaListInfoList)
            }
        })
    }else{
        region.forEach(x=>{
            if(x.level==1){
                this.shilist.push(x)
            }
        })
        if(this.shilist.length==1){
            this.shi=this.shilist[0].id
            this.mydata.areasId = this.sheng +','+ this.shilist[0].id
            this.mydata.areasName = this.userdata.areasName
        }
    }
  },
  methods: {
    reset(){
        this.$router.push('/refresh')
    },
    //   判断当前点击的按钮
    theBtn(i){
        if(i==1){
            if(this.btn.indexOf('ingredient:add')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            this.handleEdit(0)
        }else if(i==2){
            if(this.btn.indexOf('ingredient:update')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            if(this.multipleSelection.length != 1){
                return this.$message('请勾选一项内容编辑')
            }
            this.handleEdit(1,this.multipleSelection[0])
        }else if(i==3){
            if(this.btn.indexOf('ingredient:delete')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            this.choice()
        }else if(i==4){
            this.query()
        }
    },
    // 获取省市传入的id
    gainSS(i){
        this.userdata.areasId = i.id
    },
    // 查询可分配的供应商和采购员下拉框
    car(){
        this.$axios.post(`/api-s/getAllSupplier/${this.userdata.areasId}`,{},{headers:{accessToken:this.userdata.token}})
        .then(res=>{
            if(res.data.success){
                this.beginData.car = res.data.supplierInfos
            }
        })
        this.$axios.post(`/api-s/getAllBuyer/${this.userdata.areasId}`,{},{headers:{accessToken:this.userdata.token}})
        .then(res=>{
            if(res.data.success){
                this.beginData.driver = res.data.buyerInfos
            }
        })
    },
    //   多选删除
    choice(){
        if(this.multipleSelection.length == 0){
            return this.$message('请至少选择一项删除')
        }
        let arr = []
        this.multipleSelection.forEach(x=>{
            arr.push(x.id)
        })
        this.$confirm('此操作将删除选中内容, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let url = ``
            url = `/api-s/deleteIngredient/${arr.join(',')}`
            this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
            .then(res=>{
                if(res.data.success==true){
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    });
                    this.begin();
                }else{
                    alert(res.data.msg)
                }
            })
        }).catch(() => {
            return
        });
    },
    // 关闭清空内容
    dataClose(){
        if(this.shilist.length==1){
            this.mydata={isOnSale:'true',areasId:this.sheng +','+ this.shilist[0].id,areasName:this.userdata.areasName}
        }else{
            this.shi = ''
            this.mydata={isOnSale:'true'}
        }
        this.begin()
    },
    cksheng(val){
        this.$set(this,'shi','')
    },
    ckshi(val){
        this.mydata.areasId = this.sheng +','+ val
        let arr = []
        this.shenglist.forEach(x=>{
            if(this.sheng==x.id){
                arr.push(x.name)
            }
        })
        this.shilist.forEach(x=>{
            if(val==x.id){
                arr.push(x.name)
            }
        })
        this.mydata.areasName = arr.join(',')
    },
    //   多选编辑
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    //   确定
    puton(){
        if(this.mydata.areasId == undefined || this.mydata.areasId == ''){
            return this.$message('请选择所属地区')
        }
        if(!this.mydata.name||!this.mydata.num||!this.mydata.place||!this.mydata.supplierId||!this.mydata.manufacturer||!this.mydata.productionTime||!this.mydata.days||!this.mydata.buyerId||!this.mydata.warehouseTime){
            this.$message('请完善必填信息')
            return
        }
        // 判断是点击哪个
        let url = ``
        if(this.mydata.stat==0){
            url = `/api-s/addIngredient`
        }else if(this.mydata.stat==1){
            url = `/api-s/updateIngredient`
        }
        this.$axios.post(url,this.$qs.stringify(this.mydata),{ headers: { accessToken: this.userdata.token } })
        .then(res => {
            if(res.data.success){
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
                this.begin()
                this.dialogFormVisible = false
            }else{
                this.$message({
                    message:res.data.msg,
                    type: 'warning'
                })
            }
        });
    },
    pag(val){
        this.pageNum = val.pageNum
        this.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.begin()
    },
    begin() {
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        id:this.beginData.id,
        name:this.beginData.name,
        place:this.beginData.place,
        supplierName:this.beginData.supplierName,
        adminAreasId: this.userdata.areasId
      });
      this.$axios.post(`/api-s/getIngredientList`, data, {headers: { accessToken: this.userdata.token }})
        .then(res => {
            this.fullscreenLoading = false;
            if(res.data.success){
                this.$nextTick(function(){  //不使用this.$nextTick()方法会报错
                    this.$set(this, "tableData", res.data.pageInfo.list);
                });
                this.$set(this, "total", res.data.pageInfo.total);
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
            }else{
              this.$message(res.data.msg)
            }
        });
    },
    handleEdit(i,row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message('抱歉，用户暂无该权限')
        }
        this.car()
        if(i == 0){
            this.mydata.names = '添加食材'
            this.mydata.stat = i
        }else if(i == 1){
            row.names = '编辑食材'
            row.stat = i
            row.isOnSale += ''
            this.sheng = Number(row.areasId.split(',')[0])
            this.shi = Number(row.areasId.split(',')[1])
            this.mydata = row
        }
        this.dialogFormVisible = true
    },
    // 删除
    stop(row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message('抱歉，用户暂无该权限')
        }
      this.$confirm('此操作将删除该条内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          let url = ``
          url = `/api-s/deleteIngredient/${row.id}`
          this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
          .then(res=>{
              if(res.data.success==true){
                  this.$message({
                      type: 'success',
                      message: res.data.msg
                  });
                  this.begin();
              }else{
                  alert(res.data.msg)
              }
          })
      }).catch(() => {
          return
      });
    },
    query() {
      this.fullscreenLoading = true;
      this.begin();
    }
  }
};
</script>
<style>
.map {
  width: 100%;
  height: 500px;
}
#ingredient .BMap_bubble_content{
    height: 100%;
    width: 96%;
}
.w-e-toolbar{
  flex-wrap: wrap;
}
#ingredient .el-input__inner {
  margin: 10px 0;
}
#ingredient .el-menu.el-menu--horizontal{
  margin-bottom: 14px;
}
#ingredient .el-menu-item.is-active{
  background: none
}
#ingredient .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#ingredient .el-tag{
  margin-right: 12px;
}
#ingredient .el-select {
  /* margin: 0 8px; */
  width: 100%
}
#ingredient .el-upload__tip {
    display: inline-block;
    margin-left: 14px;
}
.input-new-tag{
  width: 20%
}
#ingredient .el-upload-list--picture .el-upload-list__item {
    width: 44%;
    float: left;
    margin-right: 2%;
}
#ingredient .block{
    width: 100%
}
#ingredient .block .el-date-editor.el-input,#ingredient  .el-date-editor.el-input__inner{
    width: 100%
}
#ingredient .el-form-item__content {
    /* width: 52%; */
    display: flex;
    width: 100%;
    align-items: center;
}
#ingredient .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#ingredient .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#ingredient .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
#ingredient .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#ingredient .el-dialog__body {
  height: 500px
}
#ingredient .el-form-item{
    display: flex;
    align-items: center;
    margin-bottom:0
}
#ingredient .el-form-item__label{
    width: 120px;
}
.viewer-transition {
  z-index: 9999 !important;
}
</style>
<style scoped lang="scss">
.clearfix{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.sfzimg {
  height: 48px;
}
#help .myxx p {
  margin: 5px 0;
  font-size: 16px;
}
h5 {
  text-align: center;
  margin-top: 12px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.tx{
      color: red;
    margin-left: 8px;
}
.summary>span:first-child{
    margin-right: 20px
}
.summary>span:first-child i{
    color:red
}
.summary>span:last-child i{
    color:green
}
.staimg{
    position: absolute;
    left: -26px;
    top: 10px;
    width: 18px;
}
.dtstat span{
    margin: 0 34px;
}
.site{
    position: absolute;
    top: 6%;
    z-index: 99;
    left: 2%;
}
.site input{
    width: 258px;
    line-height: 36px;
}
.xzadress{
    float: right;cursor: pointer;text-decoration: underline;color: red;margin-right: 18px;
}
</style>
